import Quill from "quill";
import { Mention, MentionBlot } from "quill-mention";
import "quill-mention/dist/quill.mention.css";
import "quill/dist/quill.snow.css";

const Parchment = Quill.import("parchment");

const DiffHighlightClass = new Parchment.Attributor(
  "diffHighlight",
  "data-diff",
  {
    scope: Parchment.Scope.INLINE_ATTRIBUTE,
  },
);

Quill.register(DiffHighlightClass, true);
Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });

type ImageFormat = { sanitize: (url: string) => string };
const Image = Quill.import("formats/image") as ImageFormat;
const ALLOWED_IMAGE_PROTOCOLS = ["http", "https", "data", "blob"];
Image.sanitize = (url: string): string => {
  const a = document.createElement("a");
  a.href = url;
  const protocol = a.href.slice(0, a.href.indexOf(":"));
  return ALLOWED_IMAGE_PROTOCOLS.includes(protocol) ? url : "//:0";
};

export default Quill;
